/** @format */

import React from "react";
import { ContextWrapper } from "./src/utils/ContextWrapper";

export const wrapRootElement = ({ element }) => <ContextWrapper>{element}</ContextWrapper>